import {oauthClientIdsSelector} from '../../../../store/state/config/selectors'
import useTypedSelector from '../../../../hooks/use-typed-selector'

import type {JSX} from 'react'

export function AdminSignInButtonGFC(): JSX.Element | null {
    const oauthClientIds = useTypedSelector(oauthClientIdsSelector)
    const isLoginEnabled = oauthClientIds != undefined

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!isLoginEnabled || !oauthClientIds || !oauthClientIds.google) {
        return null
    }

    return <div />
}
